import React, { useContext, useMemo } from "react";
import { Button } from "@chakra-ui/react";

import { Title } from "../../Components/Atoms"; 
import { Bar } from "../../Components/Organisms/Graphs";

import { MODULE_TYPES } from "../../Library/widgets";
import { getLocalisedNumber, getMean } from "../../Library/helpers";
import { StoreContext } from "../../Library/contexts";
import { ArrowRightIcon } from "../../Assets/images/svgs";
import { useNavigate } from "react-router-dom";
import PATHS from "../../Routes/paths";

const AverageRunning = ({ data }) => {
  const navigate = useNavigate();
  const { constants } = useContext(StoreContext);
  const parser = { x: "mode", y: "dst", yUnit: "km/day" };

  const processed = useMemo(() => {
    const result = {};
    const runningData = data[MODULE_TYPES.AVERAGE_RUNNING] || [];
    const distanceData = (data[MODULE_TYPES.TOTAL_RUNNING_DST] || [])[0];

    const runningEnum = constants.driveModeMap;

    const runningDataMap = Object.fromEntries(runningData.map(d => [d._id, d]));
    result.graph = Object.keys(runningEnum).filter(enm => +enm).map((key) => {
      const dataPoint = runningDataMap[key];
      const actualDst = dataPoint ? dataPoint.dst / 1000 : 0;
      return { mode: runningEnum[key].label, actualDst, dst: actualDst.toFixed(2), color: runningEnum[key].color, };
    }).filter(Boolean);

    if (distanceData) {
      result.total = (distanceData.count / 1000).toFixed(2);
    } else result.total = 0;

    return result;
  }, [ constants.driveModeMap, data ]);

  return (
    <div className="widget-group widget-1">
      <article className="widget-main">
        <header className="widget-header">
          <Title variant="md" fixed>Average Running Stats</Title>
        </header>

        <main className="widget-section">
          <div className="widget-info">
            <span className="widget-info-value">{getMean(processed.graph, "actualDst")} km</span>
            <span className="widget-info-key">{"/day/vehicle"}</span>
          </div>

          <div className="widget-chart">
            <Bar data={processed.graph} title="Average Running Stats" parser={parser} />
          </div>

          <div className="widget-info">
            <span className="widget-info-key">Total Distance: </span>
            <span className="widget-info-value">{getLocalisedNumber(processed.total)} km</span>
          </div>

          <div className="widget-link">
            <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.AVERAGE_RUNNING)}>
              View Reports
            </Button>
          </div>
        </main>
      </article>
    </div>
  );
};

export default AverageRunning;
